import script from "./DeletedMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeletedMessage.vue?vue&type=script&setup=true&lang=ts"

import "./DeletedMessage.vue?vue&type=style&index=0&id=023a7db0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-023a7db0"]])

export default __exports__